module.exports = __webpack_public_path__ + "static/media/pic2.32b62dc5.jpg";